module.exports = __webpack_public_path__ + "img/dhxx.1ee1b070.jpg";